"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles");

var _OverlayTrigger = _interopRequireDefault(require("react-bootstrap/es/OverlayTrigger"));

var _Popover = _interopRequireDefault(require("react-bootstrap/es/Popover"));

var _hostMenu = _interopRequireDefault(require("./host-menu"));

var _reactIntl = require("react-intl");

var _intlFormat = require("../../lib/intl-format");

var _translations = _interopRequireDefault(require("./translations"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var HostDropdown,
    boundMethodCheck = function boundMethodCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new Error('Bound instance method accessed before binding');
  }
};

var _default = (0, _intlFormat.withTranslations)(_translations.default, HostDropdown = function () {
  var HostDropdown =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(HostDropdown, _React$Component);

    function HostDropdown() {
      var _this;

      _classCallCheck(this, HostDropdown);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(HostDropdown).apply(this, arguments));
      _this.togglePopup = _this.togglePopup.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(HostDropdown, [{
      key: "togglePopup",
      value: function togglePopup() {
        var ref;
        boundMethodCheck(this, HostDropdown);
        return (ref = this._trigger) != null ? typeof ref.click === "function" ? ref.click() : void 0 : void 0;
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        return _react.default.createElement("div", {
          className: "HostDropdown HostMenu__dropdown",
          onClick: this.togglePopup
        }, _react.default.createElement("div", {
          className: "host"
        }, _react.default.createElement(_OverlayTrigger.default, {
          trigger: "click",
          placement: "bottom",
          overlay: this.hostMenu(),
          rootClose: true
        }, _react.default.createElement("div", {
          ref: function ref(el) {
            return _this2._trigger = el;
          }
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.host_events",
          defaultMessage: "Host Events"
        })))));
      }
    }, {
      key: "hostMenu",
      value: function hostMenu() {
        var position, props;
        props = this.props;
        position = this.props.sticky ? 'fixed' : 'absolute';
        return _react.default.createElement(_Popover.default, {
          id: "host-dropdown-menu-".concat(position)
        }, _react.default.createElement(_hostMenu.default, props));
      }
    }]);

    return HostDropdown;
  }(_react.default.Component);

  ;
  HostDropdown.propTypes = {
    onNavigate: _propTypes.default.func,
    sticky: _propTypes.default.bool
  };
  return HostDropdown;
}.call(void 0));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/navbar/host-dropdown.js
// module id = 1485
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16